import React, { useState } from "react";
import "./InstructionBanner.css";

const STORAGE_KEY = "dental_instruction_banner_hidden";
export const INSTRUCTION_PDF_URL = "/instruction.pdf";

const InstructionBanner = ({ className = "" }) => {
    const [hidden, setHidden] = useState(
        () => localStorage.getItem(STORAGE_KEY) === "1"
    );

    if (hidden) return null;

    const handleOpen = () => {
        window.open(INSTRUCTION_PDF_URL, "_blank", "noopener,noreferrer");
    };

    const handleClose = () => {
        localStorage.setItem(STORAGE_KEY, "1");
        setHidden(true);
    };

    return (
        <div className={`instruction-banner ${className}`.trim()}>
            <button
                type="button"
                className="instruction-banner__open"
                onClick={handleOpen}
            >
                Инструкция
            </button>
            <button
                type="button"
                className="instruction-banner__close"
                onClick={handleClose}
                aria-label="Скрыть баннер"
            >
                ×
            </button>
        </div>
    );
};

export default InstructionBanner;
